module.exports = __webpack_public_path__ + "img/sub-title-2.4194dd25.png";